"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretakerContract = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var CaretakerContract = (function (_super) {
    __extends(CaretakerContract, _super);
    function CaretakerContract() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.CARETAKER_CONTRACT,
            cost: 3,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(0); }),
            metadata: {
                cardNumber: '154',
                description: 'Requires 0° C or warmer.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 8 heat to increase your terraform rating 1 step.', function (eb) {
                        eb.heat(8).startAction.tr(1);
                    });
                }),
            },
        }) || this;
    }
    CaretakerContract.prototype.play = function () {
        return undefined;
    };
    CaretakerContract.prototype.canAct = function (player) {
        var hasEnoughHeat = player.availableHeat >= 8;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(constants_1.REDS_RULING_POLICY_COST) && hasEnoughHeat;
        }
        return hasEnoughHeat;
    };
    CaretakerContract.prototype.action = function (player) {
        return player.spendHeat(8, function () {
            player.increaseTerraformRating();
            return undefined;
        });
    };
    return CaretakerContract;
}(Card_1.Card));
exports.CaretakerContract = CaretakerContract;
//# sourceMappingURL=CaretakerContract.js.map